

import { cn } from '@/lib/utils';
import { Card, RARITY_CONFIG } from '@/types';

// ============================================================================
// VELOCITY V2 Player Card Compact
// ============================================================================

interface PlayerCardCompactProps {
  card: Card;
}

export function PlayerCardCompact({ card }: PlayerCardCompactProps) {
  const rarityConfig = RARITY_CONFIG[card.rarity];

  return (
    <div className="p-3 bg-surface-3 rounded-lg border border-surface-4 hover:border-tertiary transition-colors">
      <div className="flex items-center gap-3">
        <div
          className="w-1 h-10 rounded"
          style={{ backgroundColor: rarityConfig?.color || '#64748B' }}
        />
        <div>
          <p className="font-medium text-cream text-sm">{card.player?.name}</p>
          <p className="text-xs text-tertiary">
            {card.player?.team} - {card.player?.position}
          </p>
        </div>
      </div>
    </div>
  );
}

export default PlayerCardCompact;
